export default `# Meeting Integration

Connect Spectrum to a live Microsoft Teams, Google Meet, or Zoom meeting. A bot joins the call to capture transcripts and relay avatar responses to remote participants.

---

## Connecting to a Meeting

1. Select the **platform** (Teams, Google Meet, or Zoom)
2. Enter the **Meeting ID** (and passcode for Teams)
3. Optionally customise the **bot display name**
4. Choose whether to enable **transcription** and/or **recording**
5. Click **Connect Bot to Meeting**

The bot will join the meeting as a participant. Status indicators show progress:
- **Connecting** (yellow) — Bot is joining
- **Joined** (green) — Bot is in the meeting
- **Transcribing** (teal) — Actively capturing speech
- **Failed** (red) — Connection error

---

## Avatar Meeting Relay

Once connected, you can relay avatar responses directly into the meeting:

- **Speak in Meeting** — Send avatar audio to the meeting
- **Chat in Meeting** — Post avatar contributions as chat messages

Each avatar has an individual relay toggle. When enabled, that avatar's accepted contributions are sent to the meeting instead of (or in addition to) playing in the browser.

Use the **Test** button next to each avatar to verify the relay is working before going live.

---

## Live Transcript

The bottom section shows a real-time feed of everything said in the meeting:
- Speaker name and timestamp for each message
- Auto-scrolls to the latest entry

This transcript is separate from the session transcript — it captures what's said in the video call.

---

## Tips

- **Test relay before the session starts** — Use the Test button to confirm audio/chat delivery
- **Enable transcription by default** — It captures the meeting context, which enriches the session
- **Use chat relay for large meetings** — Text messages are less disruptive than audio in calls with many participants
- **Disconnect when done** — Click **Disconnect** to remove the bot from the meeting cleanly`;
